import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchBillsStats, type BillStatsData } from '../apis/fetchBillsStats';
import type { ApiResponse } from '../../../types/apiResponse';
import withPrefix from '../../../helpers/useQueryPrefix';

export const useFetchBillsStats = (): UseQueryResult<BillStatsData[], Error> => {
  return useQuery<ApiResponse<BillStatsData[]>, Error, BillStatsData[]>({
    queryKey: withPrefix(['bills-stats']),
    queryFn: fetchBillsStats,
    select: (response) => {
      if (response.status !== 200) {
        throw new Error(response.message);
      }
      return response.data as BillStatsData[];
    },
  });
};
